import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type AppRedirectStore = {
  redirectTo: string | null;
  setRedirectTo: (path: string | null) => void;
};

export const useAppRedirectStore = create(
  persist<AppRedirectStore>(
    (set) => ({
      redirectTo: null,
      setRedirectTo: (path) => set({ redirectTo: path }),
    }),
    {
      name: 'app-redirect-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
